import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { AuthApi } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';
import { TimeOutService } from 'src/app/core/time-out.service';


@Component({
  selector: 'eos-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  returnUrl: string;
  loading: boolean = true;
  policyForm = new UntypedFormGroup({
    accept: new UntypedFormControl(false, [Validators.required])
  });
  constructor(private authApi: AuthApi,
    private authService: AuthService,
    private loader: LoaderService,
    private toast: ToastService,
    private timeOut: TimeOutService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,) { }

  get canAcceptPolicy(): boolean {
    return this.authService.isAuthorised("IMM");
  }

  get isPolicyAccept(): boolean {
    return this.authService.hasAcceptedPolicy();
  }

  ngOnInit() {
    this.loader.show();


    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  privacyAccept() {
    const accpet = this.policyForm.get('accept').value
    if (!accpet) {
      this.toast.warning("Please accept the policy before clicking accept")
      return;
    }
    this.loader.show();
    this.authApi.policyAccepted(this.authService.ActiveUser.email).pipe((finalize(() => {
      this.loader.clear();
    }))).subscribe(resp => {
      this.timeOut.updatelatestUserActivity();
      this.authService.setAppUser(resp.data);

      this.commonService.delegateStatus$.next(resp.data.delegateId > 0);
      this.toast.success("Privacy policy accepted");
      this.router.navigate([this.returnUrl]);
    }, err => {

      this.toast.error("An error ocurred");
    });
  }
  onImageLoad(evt) {
    if (evt && evt.target) {
      this.loading = false;
      this.loader.clear();
    }
  }

}
